<template>
  <span>
    <a-button
      size="large"
      icon="message"
      type="primary"
      @click="openMessage()"
    ></a-button>
    <a-drawer
      title="供应商在线情况监测"
      :header-style="{ textAlign: 'center' }"
      placement="right"
      :width="400"
      :closable="false"
      :keyboard="true"
      :visible="drawerVisible"
      @close="() => (drawerVisible = false)"
    >
      <div class="monitor">
        <!-- 监控内容 -->
        <div class="monitor_notOnline mt-3">
          <a-badge status="error" text="从未进入竞价大厅的供应商" />
          <div class="monitor_notOnline_content scroll">
            <div v-for="(item, index) in notOnlineSupplier" :key="index">{{ item }}</div>
          </div>
        </div>
        <div class="monitor_online mt-2">
          <a-badge status="processing" text="供应商进出大厅日志" />
          <div class="monitor_online_content scroll">
            <div
              class="monitor_online_content_info"
              v-for="item in onlineMLogList"
              :key="item.id"
            >
              <div class="sup">
                {{ item.supplierName }}&nbsp;
                <span :style="item.status == '1' ? 'color:#00a5ed;' : 'color:#ff0000'">
                  {{ item.status == "1" ? "进入" : "离开" }}
                </span>
                <span>大厅</span>
              </div>
              <div class="time">{{ filterLogTime(item) }}</div>
            </div>
          </div>
        </div>

        <div class="monitor_footer p-2">
          <a-button class="bt-1" @click="getSupplierOnlineMLog()">刷新</a-button>
          <a-button class="bt-2 ml-1" @click="() => (drawerVisible = false)">
            关闭
          </a-button>
        </div>
      </div>
    </a-drawer>
  </span>
</template>

<script>
export default {
  name: "BidSupplierOnlineMLog", //供应商在线情况监测
  props: {
    /*  packId: {
      type: String,
    }, */
    projectId: {
      type: String,
    },
  },
  data() {
    return {
      drawerVisible: false,
      notOnlineSupplier: [],
      onlineMLogList: [],
      websock: "",
    };
  },
  beforeDestroy() {
    this.websock.close();
  },
  mounted() {
    /*  this.getSupplierOnlineMLog(this.packId);
    this.initWebSocket(this.packId); */
    this.getSupplierOnlineMLog();
    this.initWebSocket();
  },
  /*  watch: {
    packId(newValue, oldValue) {
      this.getSupplierOnlineMLog(newValue);
    },
  }, */
  methods: {
    initWebSocket: function (packid) {
      if (typeof WebSocket == "undefined") {
        console.log("您的浏览器不支持WebSocket");
      } else {
        this.websock = new WebSocket(
          "wss://" +
            process.env.VUE_APP_API_SERVER.split("//")[1] +
            "/webSocket/bidding/" +
            this.projectId +
            "/admin"
        );
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onclose = this.websocketclose;
      }
    },
    getSupplierOnlineMLog(bzid) {
      let that = this;
      this.$http
        .get("/api/v1/supplierOnlineMLog/getListByPacksId.json?xmid=" + this.projectId)
        .then(function (res) {
          that.onlineMLogList = res.result;
        });
    },
    openMessage(packId) {
      this.drawerVisible = true;
    },
    sendMessage() {
      this.websock.send();
    },
    websocketonopen() {
      console.log("WebSocket连接成功");
    },
    websocketonerror(e) {
      console.log("WebSocket连接发生错误");
    },
    websocketonmessage(e) {
      //  console.log(JSON.parse(e.data));
      if (e.data.indexOf("log") != -1 && JSON.parse(e.data).log.length != 0) {
        this.onlineMLogList.unshift(JSON.parse(e.data).log);
      }
      if (e.data.indexOf("notOnlineSupplier") != -1) {
        this.notOnlineSupplier = JSON.parse(e.data).notOnlineSupplier;
      } else {
        console.log(e.data);
      }
    },
    websocketclose(e) {
      console.log("connection closed (" + e + ")");
    },
    filterLogTime(item) {
      if (typeof item.logTime == "number") {
        return item.extras.logTime.split(/\s+/)[1];
      } else {
        return item.logTime.split(/\s+/)[1];
      }
    },
  },
};
</script>

<style lang="less" scoped>
.monitor {
  height: 50%;
  background: #fff;
  border: 2px solid #214a7c;
  .monitor_notOnline {
    padding: 0.3vw;
  }
  .monitor_notOnline_content {
    border: 2px solid #214a7c;
    height: 10vw;
    padding: 0.3vw;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }
  .monitor_online {
    padding: 0.3vw;
  }
  .monitor_online_content {
    border: 2px solid #214a7c;
    height: 10vw;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }
  .monitor_online_content_info {
    display: flex;
    justify-content: space-between;
    padding: 0.3vw;
  }
  .monitor_footer {
    display: flex;
    justify-content: flex-end;
    .bt-1 {
      color: white;
      background: #4f81bd;
    }
    .bt-2 {
      color: black;
      background: white;
    }
  }
}

.scroll::-webkit-scrollbar {
  width: 8px;
  background: white;
}

.scroll::-webkit-scrollbar-corner,
            /* 滚动条角落 */
        .scroll::-webkit-scrollbar-thumb,
        .scroll::-webkit-scrollbar-track {
  /*滚动条的轨道*/
  border-radius: 4px;
}

.scroll::-webkit-scrollbar-corner,
.scroll::-webkit-scrollbar-track {
  /* 滚动条轨道背景 */
  background-color: rgba(180, 160, 120, 0.1);
  box-shadow: inset 0 0 1px rgba(180, 160, 120, 0.5);
}

.scroll::-webkit-scrollbar-thumb {
  /* 滚动条里面的小滚动条 */
  background-color: #4f81bd;
}
</style>
